var map = {
	"./infotext_amsterdam": 1905,
	"./infotext_amsterdam.ts": 1905,
	"./infotext_groningen": 1954,
	"./infotext_groningen.ts": 1954,
	"./infotext_paris": 3214,
	"./infotext_paris.ts": 3214
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 9941;
module.exports = webpackAsyncContext;